module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_04 (2).e0523a80.png";